<template>
  <div class="content-block" :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ContentBlock",
  props: {
    paddings: Boolean
  },
  computed: {
    classes() {
      return {
        "content-block_paddings": this.paddings
      };
    }
  }
};
</script>

<style lang="scss">
.content-block {
  background-color: #fff;
  &_paddings {
    padding: 40px 50px;
  }
  @include breakpoint("md-and-down") {
    padding: 25px;
  }
  @include breakpoint("sm-and-down") {
    padding: 15px;
  }
}
</style>
